/// <amd-module name="SuiteCommerce.Blog.Common.PageTypeModel"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Common.PageTypeModel", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PageTypeModel = void 0;
    var PageTypeModel = /** @class */ (function (_super) {
        __extends(PageTypeModel, _super);
        function PageTypeModel(initializationOptions) {
            return _super.call(this, initializationOptions) || this;
        }
        Object.defineProperty(PageTypeModel.prototype, "name", {
            get: function () {
                return this.get('name');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PageTypeModel.prototype, "url", {
            get: function () {
                var url = this.get('url');
                if (url && !url.match('^\/')) {
                    url = "/" + url;
                }
                return url;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PageTypeModel.prototype, "header", {
            /* SC/SCA >= 20.2: page_header
             * SC/SCA < 20.2: header */
            get: function () {
                return this.get('header') || this.get('page_header');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PageTypeModel.prototype, "title", {
            /* SC/SCA >= 20.2: page_title
             * SC/SCA < 20.2: title */
            get: function () {
                return this.get('title') || this.get('page_title');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PageTypeModel.prototype, "fields", {
            get: function () {
                return this.get('fields');
            },
            enumerable: false,
            configurable: true
        });
        return PageTypeModel;
    }(Backbone_1.Model));
    exports.PageTypeModel = PageTypeModel;
});
